import { Suspense, useEffect, useState, type ReactNode } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { PageSkeleton } from '@/components/ui/Skeleton';
import { SettingsMasterSkeleton } from '@/modules/settings/SettingsMasterSkeleton';
import { isSettingsPath } from '@/utils/settingsBreadcrumbs';

function DelayedFallback({
  delayMs = 120,
  fallback,
}: {
  delayMs?: number;
  fallback: ReactNode;
}) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const id = window.setTimeout(() => setShow(true), delayMs);
    return () => window.clearTimeout(id);
  }, [delayMs]);
  if (!show) return null;
  return <>{fallback}</>;
}

/** Keeps shell layouts mounted while lazy route chunks load. */
export function LazyRouteOutlet({ outletKey }: { outletKey?: string | number }) {
  const location = useLocation();
  const settings = isSettingsPath(location.pathname);
  const fallback = settings ? (
    <DelayedFallback fallback={<SettingsMasterSkeleton />} />
  ) : (
    <DelayedFallback delayMs={80} fallback={<PageSkeleton />} />
  );

  return (
    <Suspense fallback={fallback}>
      <Outlet key={outletKey} />
    </Suspense>
  );
}
